// Renders either a placeholder or the details of a recommended comp selection
import { isUndefined } from '@aloft/toolkit-shared';
import { LoadingIndicator } from '@aloft/toolkit-sui';

import { useGetCompImages } from '../../../hooks/api/schema-hooks/useGetCompImages.ts';
import { RecommendedCompSelectionDetailsProps } from '../types.ts';
import { EmptyCompSelectionDetails } from './details/EmptyCompSelectionDetails.tsx';
import { PropertyCompSelectionDetails } from './details/PropertyCompSelectionDetails.tsx';

const ZillowCompSelectionDetails = ({
  property,
  subject,
  data,
  comps,
  compSelectionTableRef,
  sorting,
  setFocusedRow,
}: RecommendedCompSelectionDetailsProps) => {
  if (isUndefined(property)) return <EmptyCompSelectionDetails />;

  const { id } = property;
  const getCompImages = useGetCompImages({ pathParams: { id } }, { retry: false });

  const isFetchingCachedImages = getCompImages.isLoading;
  if (isFetchingCachedImages) return <LoadingIndicator />;

  if (getCompImages.isSuccess && getCompImages.data.images.length > 0) {
    return (
      <PropertyCompSelectionDetails
        property={{ ...property, imageUrls: getCompImages.data.images }}
        key={property.id}
        subject={subject}
        data={data}
        comps={comps}
        compSelectionTableRef={compSelectionTableRef}
        sorting={sorting}
        setFocusedRow={setFocusedRow}
      />
    );
  }

  return (
    <PropertyCompSelectionDetails
      property={property}
      key={property.id}
      subject={subject}
      data={data}
      comps={comps}
      compSelectionTableRef={compSelectionTableRef}
      sorting={sorting}
      setFocusedRow={setFocusedRow}
    />
  );
};

export const CompSelectionDetails = ({
  orderID,
  property,
  subject,
  data,
  comps,
  compSelectionTableRef,
  sorting,
  setFocusedRow,
}: RecommendedCompSelectionDetailsProps) => {
  if (isUndefined(property)) {
    return <EmptyCompSelectionDetails />;
  }

  if (property.t === 'z') {
    return (
      <ZillowCompSelectionDetails
        orderID={orderID}
        property={property}
        subject={subject}
        data={data}
        comps={comps}
        sorting={sorting}
        compSelectionTableRef={compSelectionTableRef}
        setFocusedRow={setFocusedRow}
      />
    );
  }

  return (
    <PropertyCompSelectionDetails
      property={property}
      key={property.id}
      subject={subject}
      data={data}
      comps={comps}
      sorting={sorting}
      compSelectionTableRef={compSelectionTableRef}
      setFocusedRow={setFocusedRow}
    />
  );
};
